import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {Grid,Menu,MenuItem,Avatar,IconButton} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Alert from '../../../Helper/SimpleAlert/alert';
import Card from '../../../Helper/CardWrapper/cardWrapper'
import Loader from '../../../Helper/loader/loader';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    input: {
        display: 'none',
    },
    button: {
        fontSize: '20px',
        fontWeight: 'bold',
        background: '#4284f4',
        borderRadius: '12px',
        width: '30%',
        float: 'right',
        fontFamily: 'Ropa Sans',
        textTransform: 'capitalize',
        marginBottom: '30px',
    },
    firstRefresh: {
        display: 'inline-block',
        position: 'relative',
        width:'80px !important',
        height:'80px !important',
        marginTop:'200px',
        color: '#a534a6'
    },
    refresh: {
        display: 'inline-block',
        position: 'relative',
        width:'40px !important',
        height:'40px !important',
        marginTop:'20px',
        color: '#a534a6'
    },
});

class PostEdit extends Component {
    constructor(){
        super();
        this.state = {
            feedId:'',
            post: [],
            anchorEl: null,
            isActive:false,
            total:'',
            currentCount:4,
            offset:4,
            isFetching:false,
            postListLeft:[],
            postListRight:[],
            IsFetchingPost:false,
            showAlert:false,

        }
    }
    componentDidMount(){
      this.setState({post:[]});
}
    componentWillReceiveProps(nextProps) {
        this.setState({
            post: nextProps.postData.LocalFeedList,
            total: nextProps.postData.LocalFeedList.length,
            //feedId:nextProps.postData.
        },()=>{this.loadInitialContent()})
    }
  showAlert=()=>{
    let {showAlert} = this.state;
    showAlert=!showAlert;
    this.setState({ showAlert });
  }
    loadInitialContent=()=>{
        let postListLeft=[];
        let postListRight=[];
        let {post, offset} = this.state;
        let ary = post && post.slice(0,offset);
        ary.forEach((val,i)=>{
          if(i<(ary.length/2))
            postListLeft.push(val);
          else
            postListRight.push(val)
        })

        this.setState({post:ary,
                      postListLeft,
                      postListRight});
    };
  convertUnicode = (input) => {
    return input.replace(/\\u(\w\w\w\w)/g,(a,b) => {
      let charcode = parseInt(b,16);
      return String.fromCharCode(charcode);
    });
  };
    // loadOnScroll = () =>{
    //     let {currentCount, isFetching, offset, total} = this.state;
    //     if(currentCount === total) return;
    //     let el = document.getElementById('edit-end');
    //     let rect = el.getBoundingClientRect();
    //     let isAtEnd = (
    //         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    //         rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    //     );
    //     if(isAtEnd){
    //         if(!isFetching){
    //             this.setState({isFetching:true});
    //             setTimeout(() => {
    //                 let count = currentCount + offset;
    //                 if(currentCount !== total){
    //                     this.setState({
    //                         isFetching:false,
    //                         currentCount:count,
    //                         post: this.props.postData.LocalFeedList.slice(0, count)
    //                     })
    //                 }
    //             }, 2000);
    //         }
    //     }
    // };
  checkProfileImg=(url)=>{
    const {user}=this.props;
    if(url=== null || url==="" ){
      return <img  src={require(`../../../images/Alphabets/${user.results.AppUser.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)} height={50} width={50}/>
    }else{
      return  <img src={`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${url}`} height={50} width={50}/>
    }
  };
    checkFormat = (date) => {
        let arr = date.split(' ');
        return arr[0];
    };

    handleClick = (feedId,postComment) => (e) => {
        this.setState({ anchorEl: e.currentTarget,feedId:feedId,postComment:postComment });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleDelete = () => {
        let {feedId} = this.state;
        this.alertBox(feedId);
        this.setState({ anchorEl: null });
        this.props.deleteCount(1);
    };

    DeletePostFeedId = () =>{
        let {feedId} = this.state;
        this.props.onUpload(feedId,'Delete');
    };

    alertBox = (feedId) =>{
      this.DeletePostFeedId();
        this.setState({
            feedId: feedId,
          showAlert:!this.state.showAlert,
          msg:'Post Deleted successfully!'
        });
        // swal({
        //     title: "Are you sure?",
        //     text: "Once deleted, you will not be able to recover this post!",
        //     icon: "warning",
        //     buttons: true,
        //     dangerMode: true,
        // })
        //     .then((willDelete) => {
        //         if (willDelete) {
        //             this.DeletePostFeedId();
        //             swal("Poof! Your post has been deleted!", {
        //                 icon: "success",
        //             });
        //         } else {
        //             swal("Your post is safe!");
        //         }
        //     });
    };
  displayFormat=(post)=>{
    let arr;
    let arr2;
    let postArr=[];
    if(post!==null && post!=="") {
      arr = post.split("\n");
      arr.forEach((v) => {
        arr2=v.split(" ");
        arr2.forEach((a)=>{
          if (a.charAt(0) === '#')
            postArr.push("<span style='color:blue'>" + a + "</span>");
          else if(a.indexOf('#')!==-1){
            let inword=(a.split('#'))
            postArr.push(inword[0]+"<span style='color:blue'>#"+inword[1] + "</span>");
          }
          else{
            postArr.push(this.convertUnicode(a))
          }

        })
        postArr.push('<br/>');
      })
      return postArr.join(" ");
    }
    else return '';
  }
  handleUpdate=()=> {
    let {feedId,postComment} = this.state;
    this.props.onEdit(postComment,feedId);
    this.setState({ anchorEl: null });
  }

    render() {
        const { user, postData } = this.props;
        const {anchorEl,showAlert,msg} = this.state;
        let postListLeft=[];
        let postListRight=[];
        postData.LocalFeedList.forEach((val,i)=>{
          if(i<(postData.LocalFeedList.length/2))
              postListLeft.push(val);
          else
            postListRight.push(val)
      })
        return (
            <div className="post-edit-card-css" onScroll={this.props.scroll}>
              <Alert showSuccess={showAlert || this.props.showAlert} showError={false} Msg={showAlert ? msg : 'Updated Successfully.'} onClose={()=>{
                showAlert ? this.showAlert() : this.props.toggleAlert()
              }} />
              <Grid container spacing={24}>
                <Grid item sm={12} xs={12} md={6} className="post-edit-grid">
                  {
                    postListLeft.map((postLeft, i) => {
                        return postLeft && <Card
                            content={
                                <div className="post-edit-css" key={i}>
                                    <div className="locationDate-left">
                                        <i className="fa fa-calendar"
                                           aria-hidden="true"/>&nbsp;{postLeft && moment(postLeft.CreatedDate).format('MMM Do')}&nbsp;&nbsp;&nbsp;
                                        <i className="fa fa-map-marker"
                                           aria-hidden="true"/>&nbsp;{Math.floor(postLeft.Distance) > 0 ? `${Math.floor(postLeft.Distance)} miles` : 'less than a mile'}
                                    </div>
                                    <div style={{display: 'flex', boxShadow: 'unset'}}>
                                        <div className="avatar-post-img">
                                            <Avatar className="avatar-post">
                                                {this.checkProfileImg(user.results.AppUser.ProfileImage)}
                                            </Avatar>
                                        </div>
                                        <div style={{width: '90%', marginRight: '5px'}}>
                                            <div style={{display: 'flex', width: '100%'}}>
                                                <div className="user-name-id-post">
                                                    <h4 className="username-name-id-post-left">{user.results.AppUser.FirstName}</h4>
                                                    <h5 className="username-name-id-editPost-left">{`@${user.results.AppUser.UserName}`}</h5>
                                                </div>
                                                <div style={{width: '14%'}}>
                                                    <IconButton
                                                        aria-label="More"
                                                        aria-owns={anchorEl ? 'long-menu' : null}
                                                        aria-haspopup="true"
                                                        onClick={this.handleClick(postLeft.FeedId, postLeft.PostComment)}
                                                        style={{fontSize: '18px'}}
                                                    >
                                                        <MoreVertIcon/>
                                                    </IconButton>
                                                    <Menu
                                                        id='long-menu'
                                                        anchorEl={anchorEl}
                                                        open={Boolean(anchorEl)}
                                                        onClose={this.handleClose}
                                                        PaperProps={{
                                                            style: {
                                                                maxHeight: 48 * 4.5,
                                                                width: 200
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem style={{fontSize: '18px'}}
                                                                  onClick={this.handleUpdate}><i
                                                            className="fa fa-pencil-square-o"
                                                            aria-hidden="true"/>&nbsp;Edit
                                                            Post</MenuItem>
                                                        <MenuItem style={{fontSize: '18px'}}
                                                                  onClick={this.handleDelete}><i
                                                            className="fa fa-trash"
                                                            aria-hidden="true"/>&nbsp;&nbsp;Delete
                                                            Post</MenuItem>
                                                    </Menu>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{display: 'flex', margin: '5px 10px 5px 15px'}}>
                                        <div className="post-display-left">
                                            <p className="post-text"
                                               dangerouslySetInnerHTML={{__html: this.displayFormat(postLeft.PostComment)}}/>
                                            {
                                                postLeft.LocalFeedImage.length > 1000 ? postLeft.isImage === 'YES' ?
                                                    <img src={`data:image/jpeg;base64,${postLeft.LocalFeedImage}`}/>
                                                    : postLeft.isVideo === 'YES' &&
                                                    <video controls="controls" id="video">
                                                        <source src="sintel-trailer.ogv"
                                                                type='video/ogg; codecs="theora, vorbis"'/>
                                                        <source src={`data:video/mp4;base64,${postLeft.LocalFeedVideo}`}
                                                                type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                                                    </video>
                                                    : postLeft.LocalFeedImage !== '' ?
                                                    <img src={postLeft.LocalFeedImage}/>
                                                    : postLeft.isVideo === 'YES' &&
                                                    <video controls="controls" id="video">
                                                        <source src="sintel-trailer.ogv"
                                                                type='video/ogg; codecs="theora, vorbis"'/>
                                                        <source src={postLeft.LocalFeedVideo}
                                                                type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                                                    </video>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            CardContentProps={{
                                style: {border: '1px solid gainsboro', marginBottom: '15px', padding: '16px'}
                            }}
                        />
                    })
                  }
                </Grid>
                <Grid item sm={12} xs={12} md={6} className="post-edit-grid">
                  {
                    postListRight.map((postRight, i) => {
                        return postRight && <Card
                            content={
                                <div className="post-edit-css" key={i}>
                                    <div className="locationDate">
                                        <i className="fa fa-calendar"
                                           aria-hidden="true"/>&nbsp;{postRight && moment(postRight.CreatedDate).format('MMM Do')}&nbsp;&nbsp;&nbsp;
                                        <i className="fa fa-map-marker"
                                           aria-hidden="true"/>&nbsp;{Math.floor(postRight.Distance) > 0 ? `${Math.floor(postRight.Distance)} miles` : 'less than a mile'}
                                    </div>
                                    <div style={{display: 'flex', boxShadow: 'unset'}}>
                                        <div className="avatar-post-div">
                                            <Avatar className="avatar-post">
                                                {this.checkProfileImg(user.results.AppUser.ProfileImage)}
                                            </Avatar>
                                        </div>
                                        <div className="" style={{width: '90%'}}>
                                            <div style={{display: 'flex', width: '100%'}}>
                                                <div className="user-name-id">
                                                    <h4 className="username-name-id">{user.results.AppUser.FirstName}</h4>
                                                    <h5 className="username-name-id-editPost">{`@${user.results.AppUser.UserName}`}</h5>
                                                </div>
                                                <div className="post-edit-button-wrapper">
                                                    <IconButton
                                                        aria-label="More"
                                                        aria-owns={anchorEl ? 'long-menu' : null}
                                                        aria-haspopup="true"
                                                        onClick={this.handleClick(postRight.FeedId, postRight.PostComment)}
                                                        style={{fontSize: '18px'}}
                                                    >
                                                        <MoreVertIcon/>
                                                    </IconButton>
                                                    <Menu
                                                        id='long-menu'
                                                        anchorEl={anchorEl}
                                                        open={Boolean(anchorEl)}
                                                        onClose={this.handleClose}
                                                        PaperProps={{
                                                            style: {
                                                                maxHeight: 48 * 4.5,
                                                                width: 200
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem style={{fontSize: '18px'}}
                                                                  onClick={this.handleUpdate}><i
                                                            className="fa fa-pencil-square-o"
                                                            aria-hidden="true"/>&nbsp;Edit Post</MenuItem>
                                                        <MenuItem style={{fontSize: '18px'}}
                                                                  onClick={this.handleDelete}><i
                                                            className="fa fa-trash"
                                                            aria-hidden="true"/>&nbsp;&nbsp;Delete
                                                            Post</MenuItem>
                                                    </Menu>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{display: 'flex'}}>
                                        <div className="post-disply-caption"/>
                                        <div className="post-display">
                                            <p className="post-text"
                                               dangerouslySetInnerHTML={{__html: this.displayFormat(postRight.PostComment)}}/>
                                            {
                                                postRight.LocalFeedImage.length > 1000 ? postRight.isImage === 'YES' ?
                                                    <img src={`data:image/jpeg;base64,${postRight.LocalFeedImage}`}/>
                                                    : postRight.isVideo === 'YES' &&
                                                    <video controls="controls" id="video">
                                                        <source src="sintel-trailer.ogv"
                                                                type='video/ogg; codecs="theora, vorbis"'/>
                                                        <source
                                                            src={`data:video/mp4;base64,${postRight.LocalFeedVideo}`}
                                                            type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                                                    </video>
                                                    : postRight.LocalFeedImage !== '' ?
                                                    <img src={postRight.LocalFeedImage}/>
                                                    : postRight.isVideo === 'YES' &&
                                                    <video controls="controls" id="video">
                                                        <source src="sintel-trailer.ogv"
                                                                type='video/ogg; codecs="theora, vorbis"'/>
                                                        <source src={postRight.LocalFeedVideo}
                                                                type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                                                    </video>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            CardContentProps={{
                                style: {border: '1px solid gainsboro', marginBottom: '15px', padding: '16px'}
                            }}
                        />
                    })
                  }
                </Grid>
              </Grid>
              {
                !postData.IsFetchingPost ? <div className='text-center'><Loader/></div>
                  :
                  (!postData.LocalFeedList.length > 0) &&
                  <div className='no-data-div'>@{user.results.AppUser.UserName}<br/> Doesn’t have any
                    posts to show.</div>
              }
            </div>
        )
    }
}
PostEdit.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps=(state)=> {
    return {
        user:state.loginResponse
    }
};
export default withStyles(styles)(connect(mapStateToProps)(PostEdit));
